import React, { useState } from "react";
import { 
	Skeleton, 
	Row, 
	Col, 
	Button, 
	Checkbox, 
	Input, 
	message
} from "antd";

import { 
	EntitiesList, 
	EditEntityDrawer, 
	AddEntityDrawer, 
	admitedEntities, 
	ImportEntitiesDrawer
} from "../components/entities";

import PropTypes from "prop-types";
import { get_entities, edit_entity } from "../services";
import { useGetSpecificDataCompanyHook } from "../hooks";
import "../styles/hover.css";
import { CircleAnimationCompact } from "../components/loading";
import { WaitingForACompany } from "../components/WaitingForACompany";

const isCompanySelected = (company) => company.id.trim() !== "";

const entitiesFilter = (entities, isArchieved) => {
	const filteredClients = isArchieved ? 
		entities.filter(client => client.state === "archieved") : 
		entities.filter(client => client.state === "active") ;
	return filteredClients;
};

// originalClients, setOriginalClients
export const EntitiesPage = ({token, user, company, entitySelected = ""}) => {
	if(!admitedEntities[entitySelected]){
		message.error("Error del Developer: Entidad ingresada en el componente es invalida");
		return <></>;
	}
	
	const [selectedEntity, setSelectedEntity] = useState(null);
	const [showArchievedClients, setShowArchievedClients] = useState(false);
	const [openAddClient, setOpenAddClient] = useState(false);
	const [openEditClient, setOpenEditClient] = useState(false);
	const [openImportClients, setOpenImportClients] = useState(false);

	const specialFilterEntities = (entitiesData) => {
		return entitiesFilter(entitiesData, showArchievedClients);
	};	

	const fetchClients = async(token, company_id) => {
		return await get_entities(token, company_id, entitySelected);
	};
	
	const editEntityClient = async(token, edit_Value, data) => {
		return await edit_entity(token, edit_Value, data, entitySelected);
	};
	
	const {
		data: entities,
		setData: setEntities,
		backupData: backupClients,
		loading,
		addNewData: addNewClient,
		updateData: updateSelectedClient,
		importData
	} = useGetSpecificDataCompanyHook(company, fetchClients, token, editEntityClient, {
		entityKey: entitySelected, 
		specialFilterFunction: specialFilterEntities
	});
	
	const onChangeSearch = (value) => {
		const text = value.target.value;

		const clientsFilteredByStatus = entitiesFilter(backupClients, showArchievedClients);
		
		const filteredClients = clientsFilteredByStatus.filter(client => {
			const name = client.name.toLowerCase();
			const description = client.description.toLowerCase();
			const contacts = client.contacts.map(contact => {
				const contactName = contact.name.toLowerCase();
				const contactEmail = contact.email.toLowerCase();
				const contactPhone = contact.phone.toLowerCase();
				return `${contactName} ${contactEmail} ${contactPhone}`;
			}).join(" ");
	
			return name.includes(text.toLowerCase()) || description.includes(text.toLowerCase()) || contacts.includes(text.toLowerCase());
		});
	
		setEntities(filteredClients);		
	};
			
	return (
		<>
			<WaitingForACompany company_id={company.id}/>
			{
				company.id !== "" && 
				<>
					{/* MAIN SKELETON FOR SHOW CLIENTS */}
					{
						loading &&
						<CircleAnimationCompact/>
					}
					{
						!loading &&
						<Skeleton avatar loading={loading}>
							{/* OPTIONS FOR CLIENTS LIST */}
							<Row>
								<Col span={6}>
									<Button 
										disabled={(!isCompanySelected(company))}
										type="primary"
										style={{marginTop: "10px"}}
										onClick={() => setOpenAddClient(true)}
										ghost
									>
										Agregar {admitedEntities[entitySelected].single}
									</Button>														
								</Col>
								<Col span={6}>
									<Input
										disabled={(!isCompanySelected(company))}
										placeholder="Buscar..."
										style={{
											marginTop: "10px",
											marginBottom: "10px",
										}}
										onChange={onChangeSearch}
									/>
								</Col>
								<Col span={6}>
									<Button 
										disabled={(!isCompanySelected(company))}
										type="primary"
										style={{marginTop: "10px"}}
										onClick={() => setOpenImportClients(true)}
										ghost
									>
										Importar
									</Button>														
								</Col>
								<Col span={6}>
									<Checkbox 
										disabled={(!isCompanySelected(company))}
										checked={showArchievedClients} 
										onChange={(e) => {
											const value = e.target.checked;								
											setEntities(entitiesFilter(backupClients, value));
											setShowArchievedClients(value);
										}}
										style={{marginTop: "13px"}}
									>
										Mostrar Archivados
									</Checkbox>
								</Col>
							</Row>
							{/* LIST OF CLIENTS */}
							<EntitiesList 
								entities={entities}
								onClientSelected={(value) => {
									setSelectedEntity(value);
									setOpenEditClient(true);
								}}
								entitySelected={entitySelected}
							/>
						</Skeleton>
					}
					{/* DRAWER FOR ADD ENTITY */}
					<AddEntityDrawer
						token={token}
						company_id={company.id}
						entities={entities}
						openAddClient={openAddClient}
						onOpenAddClient={(value) => setOpenAddClient(value)}
						addNewClient={addNewClient}
						entitySelected={entitySelected}
					/>

					{/* DRAWER FOR EDIT ENTITY */}
					<EditEntityDrawer 
						token={token}
						user={user}
						client={selectedEntity} 
						openEditClient={openEditClient}
						onOpenEditClient={(value) => setOpenEditClient(value)}
						onClientToEdit={(value) => updateSelectedClient(value)}
						entitySelected={entitySelected}
					/>

					{/* DRAWER FOR IMPORT ENTITIES */}
					<ImportEntitiesDrawer 
						token={token}
						company_id={company.id}
						entities={entities}
						openAddClient={openImportClients}
						onOpenAddClient={(value) => setOpenImportClients(value)}
						importData={importData}
						entitySelected={entitySelected}
					/>
				</>
			}
		</>
	);
};

EntitiesPage.propTypes = {
	token: PropTypes.string.isRequired,
	user: PropTypes.object.isRequired,
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	}).isRequired,
	entitySelected: PropTypes.string.isRequired,
	originalClients: PropTypes.array,
	setOriginalClients: PropTypes.func.isRequired,
};
